import React from 'react';
import { motion } from 'framer-motion';

const Marquee = () => {
  const text = "CALIDAD PREMIUM • SABOR AUTÉNTICO • EXPERIENCIA GOURMET • ";
  const repeatedText = text.repeat(10);

  return (
    <section className="py-12 bg-gradient-to-r from-orange-500 via-amber-500 to-orange-500 overflow-hidden">
      <motion.div
        className="flex whitespace-nowrap"
        animate={{ x: [0, -1920] }}
        transition={{
          duration: 30,
          repeat: Infinity,
          ease: "linear"
        }}
      >
        <span className="text-4xl md:text-6xl font-black text-black">
          {repeatedText}
        </span>
      </motion.div>
    </section>
  );
};

export default Marquee;